import {appleStore, googleStore} from "@/shared/constants";

export const constants = {
    computed: {
        appleStore() { return appleStore },
        googleStore() { return googleStore }
    }
}
